export class YoutubeVideo {
	videoId: string;
	youTubeUrl: string;

	public setVideoUrl(url: string) {
		this.youTubeUrl = url;
		this.videoId = this.parseYoutubeUrl(url);
	}

		private parseYoutubeUrl(url: string) {
		let regExp = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/
		let match = url.match(regExp)
		if (match && match[1].length === 11 ) {
			return match[1]
		} else {
			return null
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/models/youtube-video.model.ts